import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Segment, Tab } from 'semantic-ui-react'

import {
    getMHCRewardsCategoryList,
} from '../../actions';
import RewardsCategoryList from '../../component/rewards/rewards_category_list';

class RewardsCategoryPage extends Component {
    componentDidMount() {
        this.fetchRewardCategoryList()
    }

    componentDidUpdate(prevProps) {
        const { contactNoVerified } = prevProps;
        if (contactNoVerified !== this.props.contactNoVerified) {
            this.fetchRewardCategoryList();
        }
    }

    fetchRewardCategoryList(){
        const {accessToken} = this.props.user;
        this.props.getMHCRewardsCategoryList(accessToken);
    }

    render() {
        console.log('RewardsPage', this.props);
        const panes = [
            { menuItem: 'Category', render: () => <Tab.Pane><RewardsCategoryList category={this.props.rewardsCategoryList} /></Tab.Pane> },
          ]
        return (
            <Tab panes={panes} />
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        rewardsCategoryList: state.appConfig.rewardsCategoryList,
        contactNoVerified: state.otp.contactNoVerified,
    }
}

export default connect(mapStateToProps, {
    getMHCRewardsCategoryList,
})(RewardsCategoryPage);
